import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { CurrentMatchedPatentState } from '../types';

/**
 * 当前匹配专利排行榜模型
 * @description 存储当前匹配专利排行榜状态
 */
export interface CurrentMatchedPatentModel extends Model<CurrentMatchedPatentState>, Disposable {

}

export const CurrentMatchedPatentModel = Symbol.for('CurrentMatchedPatentModel');
